module.exports = __webpack_public_path__ + "static/media/Mass_start.c1b2fd74.mp4";